export class CandidateEntry
{
  candidateEntryId: number;
  dateEntry: Date;
  dateOut: Date;
  url: string;
  wasError: boolean;
  sumbittedForm: boolean;
  iP: string;
  }
